export default "__VITE_ASSET__cKLjB9nh__"